import { PATIENT_TABLE_NAMES, ALL_ROUTES } from 'config/routes';
import permissions from 'config/permissions';
import { checkPermission } from 'helpers/checkPermissions';
import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as RemoveIcon } from 'assets/icons/remove.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
  navigateToRoute,
} from '../../../../redux_store';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';

const RowActions = ({
                      row,
                      setAnchorEl,
                      setSelectedPatient,
                      setOrderPatient,
                      togglePatientEditModal,
                      setOpenRemoveDialog,
                      setRemovingPatient,
                    }) => {
  const { en: { titles, notifications } } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const {
    metadata: {
      currentAccount,
      currentAccountPermissions,
      childAccountPermissions,
    },
    isDistributionSponsor,
  } = useSelector((state) => state.user);

  const handleCreateOrderClick = (e, patient) => {
    const hasPermission = checkPermission(
      patient.accountUUID === currentAccount.uuid
        ? currentAccountPermissions
        : childAccountPermissions,
      permissions.ORDER_CREATE,
    );
    if (hasPermission) {
      setSelectedPatient({
        patientUuid: patient.uuid,
        accountUuid: patient.accountUUID,
      });
      setOrderPatient(patient);
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.notPermissionForCreatingOrder,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
          },
        }),
      );
    }
  };

  const handleCreateAssessmentClick = (
    e,
    { uuid, accountUUID, firstName, lastName },
  ) => {
    const hasPermission = checkPermission(
      accountUUID === currentAccount.uuid
        ? currentAccountPermissions
        : childAccountPermissions,
      permissions.ORDER_SURVEY_CREATE,
    );
    if (hasPermission) {
      const isItChildAccount = accountUUID !== currentAccount.uuid && isDistributionSponsor;
      dispatch(navigateToRoute({ route: {
        path: (isItChildAccount ? ALL_ROUTES.patient.dashboardDS : ALL_ROUTES.patient.dashboard).path + '?q=create',
        params: {
          currentAccountUuid: currentAccount.uuid,
          accountUuid: isItChildAccount ? accountUUID : null,
          patientUuid: uuid,
          tableName: PATIENT_TABLE_NAMES.assessment,
        },
        title: `${titles.patientDashboard}: ${firstName} ${lastName}`,
      }}));
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.notPermissionForCreatingAssessment,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
          },
        }),
      );
    }
  };

  const handleEditItemClick = (e, { uuid, accountUUID }) => {
    setSelectedPatient({
      patientUuid: uuid,
      accountUuid: accountUUID,
    });
    togglePatientEditModal(true);
  };

  const handleRemoveItemClick = (e, patient) => {
    setOpenRemoveDialog(true);
    setRemovingPatient(patient);
  };

  return <>
    <MenuItem
      title={titles.createOrder}
      icon={<AddIcon />}
      setAnchorEl={setAnchorEl}
      onClick={(e) => handleCreateOrderClick(e, row)}
    />
    <MenuItem
      title={titles.createAssessment}
      icon={<AddIcon />}
      setAnchorEl={setAnchorEl}
      onClick={(e) => handleCreateAssessmentClick(e, row)}
    />
    <MenuItem
      title={titles.editPatient}
      icon={<EditIcon />}
      setAnchorEl={setAnchorEl}
      onClick={(e) => handleEditItemClick(e, row)}
      hasTopDriver
    />
    <MenuItem
      title={titles.removePatient}
      icon={<RemoveIcon />}
      setAnchorEl={setAnchorEl}
      onClick={(e) => handleRemoveItemClick(e, row)}
      isErrorStyle
    />
  </>;
};

export default RowActions;
